<template>
  <div>
    <div class="nav">
      <div class="content">
        <div class="mtcal">{{ styletext }}
        <div class="fontSize"><span>{{ remark }}</span></div></div>
        <div class="btnBox">
          <el-button class="btn" @click="goabout()">联系我们</el-button>
        </div>
      </div>

      <el-row style="min-width: 100%">
        <!-- <el-col style="padding-left: 15.5%"> -->
        <div class="contents" v-sticky="{ zIndex: 100, stickyTop: 50, disabled:false}">
          <p
              class="titleimg"
              style="
              border-bottom: 2px solid #2a67e3;
              line-height: 50px;
              color: #2a67e3;
              margin: 20px 5px 0 5px;
              font-weight: bold;
            "
          >
            {{ contentcolumnText }}
          </p>
          <p
              class="titleimg"
              v-for="(item, index) in contentList"
              :key="index"
              @click="styleIndex = index"
              :class="{ titleimg2: index === styleIndex }"
          >
<!--            <span @click="getContent2(item)">{{ item.columnText }}</span>-->
            <span @click="contentcolumnText=='关于我们' || contentcolumnText == '可信数据空间产品系列' || contentcolumnText == '国产自主可控联盟链基础设施产品' || contentcolumnText == '空天地海潜一体柔性复合防御无人值守集群平台' || contentcolumnText == '异构无人集群自主多域作战弹性指控平台产品' || contentcolumnText == '保障仿真筹划管控运维系统产品'?toLink(item.columnText):getContent2(contentcolumnText)">{{ item.columnText }}</span>

            <img
                class="image"
                src="../../assets/scheme/Page3.png"
                alt=""
                v-show="index === styleIndex"
                style="width: 6px; height: 8px"
            />
          </p>
        </div>
        <!-- </el-col> -->
        <!-- <el-col :span="15" > -->
        <el-row class="content_tyle">
          <div class="subView">
            <div class="subView_list">
              <div
                  class="subView_item"
                  v-for="item in textdata.list"
                  :key="item.index"
              >
                <template>
                  <div class="title" :id="item.columnText">{{item.columnText}}</div>
                  <div class="border"></div>
                  <div class="text" v-if="item.remark == '1'">
                    <div v-for="item2 in item.list">
<!--                      <el-link type="primary" v-if="item.orderNum == 1 && lineText=='StorNet'" @click="skip('StorNet')">{{lineText}}</el-link>-->
                      {{item2.columnText}}
                    </div>
                  </div>
                  <div class="text" v-if="item.remark == '2'">
                    <div v-for="item2 in item.list">
                      <div>
<!--                        {{lineText}}-->
<!--                        <template v-if="item.orderNum==1 && item2.orderNum == 0">-->
<!--                          (-->
<!--                          <el-link type="primary"  @click="skip(lineText == '国产PKMT平台'?'区块链BASS平台V4.0':'隐私计算数据服务平台')">{{lineText == "国产PKMT平台"?"区块链BASS平台V4.0":"隐私计算数据服务平台"}}</el-link><span style="color: #409EFF">、</span>-->
<!--                          <el-link type="primary"  @click="skip(lineText == '国产PKMT平台'?'区块链BASS平台V3.0':'隐私计算服务管理平台')">{{lineText == "国产PKMT平台"?"区块链BASS平台V3.0":"隐私计算服务管理平台"}}</el-link>-->
<!--                          )-->
<!--                        </template>-->
                        {{item2.columnText}}
                      </div>
                      <div style="padding: 10px 0" v-if="item2.columnImg==null"></div>
                      <div style="padding: 20px 0" v-if="item2.columnImg!=null"><img :src="item2.columnImg" width="100%" alt=""></div>
                    </div>
                  </div>
                  <div class="text" v-if="item.remark == '3'">
                    <div v-for="item2 in item.list">
                      <div style="padding: 20px 0"><img :src="item2.columnImg" width="100%" alt=""></div>
                    </div>
                  </div>
                  <div class="text" v-if="item.remark == '4'">
                    <div v-for="item2 in item.list" style="width: 100%">
                      <div v-if="item2.remark !=null" style="color: #2A67E3;font-size: 18px;font-weight: 500;"><i class="el-icon-caret-right"></i>&emsp;{{item2.remark}}</div>
                      <div v-if="$route.query.item == '传感网络' || $route.query.item == '设备运维保障业务训练系统'">
                        <div v-if="item2.columnText!=null" style="padding: 20px 0;font-size: 14px;white-space:pre-wrap">{{item2.columnText}}</div>
                        <div style="padding: 20px 0;display: flex; justify-content: center;" v-if="item2.columnImg!=null"><img :src="item2.columnImg"  style="width: 100%" alt="" ></div>
                      </div>
                      <div v-else>
                        <div style="padding: 20px 0;display: flex; justify-content: center;" v-if="item2.columnImg!=null"><img :src="item2.columnImg"  style="width: 100%" alt="" ></div>
                        <div v-if="item2.columnText!=null" style="padding: 20px 0;font-size: 14px;;white-space:pre-wrap">{{item2.columnText}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="text" v-if="item.remark == '5'">
                    <div v-for="item2 in item.list">
                      <div style="padding: 20px 0"><img :src="item2.columnImg" width="100%" alt=""></div>
                    </div>
                    <el-row style="width: 90%;">
                      <el-col :span="6">
                        <el-button style="background-color: #056DFF;color: white;padding: 12px 0">
                          <a href="https://mtbaas.trilliontrust.com/#/mtBaaS" target="_blank" style="color: white;padding: 12px 57px">立即体验</a>
                        </el-button>
                      </el-col>
                      <el-col :span="6">
                        <el-button style="background-color: #056DFF;color: white;padding: 12px 0">
                          <a href="https://mtbaas.trilliontrust.com/#/mtBaaS/filePage" target="_blank" style="color: white;padding: 12px 57px">开发手册</a>
                        </el-button>
                      </el-col>
                      <el-col :span="6">
                        <el-button style="background-color: #056DFF;color: white;padding: 12px 0">
                          <a href=" https://enode.trilliontrust.com/#/" target="_blank" style="color: white;padding: 12px 57px">演示平台</a>
                        </el-button>
                      </el-col>
                      <!--                                        <el-col :span="6"><el-button style="background-color: #056DFF;color: white;width: 170px">视频演示</el-button></el-col>-->
                    </el-row>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-row>
        <!-- </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Mtcal from "./mtcal";
import Stornet from "./stornet";
import Hashstor from "./hashstor";
import VueSticky from "vue-sticky";
export default {
  name: "picture-cen-app.vue",
  data() {
    return {
      lineText:"",
      contentList: [],
      styleIndex: 0,
      contentcolumnText: "",
      dataitem: {},
      styletext: "",
      textdata: {},
      remark: "",
    };
  },
  directives: {
    'sticky': VueSticky,
  },
  created() {
    this.getList(this.$route.query.item);
    this.contentcolumnText = this.$route.query.item;
    this.styletext = this.$route.query.text;
    this.getContent(this.$route.query.text);
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.text) {
          //需要监听的参数
          this.getList(this.$route.query.item);
          this.styletext = this.$route.query.text;
          this.getContent(this.$route.query.text);
          this.contentcolumnText = this.$route.query.item;
        }
      },
    },
  },
  methods: {
    toLink(item){
// 获取目标元素
      const element = document.getElementById(item);
      // 假设导航栏的高度为 60px
      const navbarHeight = 280;
      // 获取元素的位置信息
      const rect = element.getBoundingClientRect();
      // 计算滚动位置
      window.scrollTo({
        behavior: 'smooth',
        top: window.scrollY + rect.top - navbarHeight
      });
    },
    goabout() {
      this.$router.push({
        name: "about-app",
      });
    },
    getList(item) {
      axios
          .get(
              "https://article.chenhaninfo.com/publish-article/sys/column/columnList",
              {}
          )
          .then(({ data }) => {
            if (data && data.code === 0) {
              for (let item2 of data.list) {
                if (item2.columnText === "空天地海潜一体柔性复合防御无人值守集群平台" || item2.columnText === "可信数据空间产品系列" || item2.columnText === "国产自主可控联盟链基础设施产品" || item2.columnText === "异构无人集群自主多域作战弹性指控平台产品" || item2.columnText == "保障仿真筹划管控运维系统产品" || item2.columnText === "关于我们" || item2.columnText === "隐私计算产品") {
                  for (let item3 of item2.list) {
                    if (item3.columnText == "荣誉资质" && item =="关于我们") {
                      this.contentList = item3.list;
                      this.getText();
                    }else if (item3.columnText === item) {
                      this.contentList = item3.list;
                      this.getText();
                    }
                  }
                }
              }
            } else {
            }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getText() {
      for (var i = 0; i < this.contentList.length; i++) {
        if (this.$route.query.text == this.contentList[i].columnText) {
          this.remark = this.contentList[i].remark;
          this.styleIndex = i;
        }
      }
    },
    getContent2(item) {
      axios
          .get(
              "https://article.chenhaninfo.com/publish-article/sys/column/byName?text=" +
              item,
              {}
          )
          .then(({data}) => {
            if (data && data.code === 0) {
              if ((this.$route.query.item == "兆隐-国产区块链多方安全隐私计算联邦学习平台MP" || this.$route.query.item == "兆群：战术级边端侧无人武器装备集群侦控打智能协同指挥控制平台") && this.$route.query.text == "产品介绍"){
                data.list = data.list.filter((item) => {
                  if (this.$route.query.item == "兆隐-国产区块链多方安全隐私计算联邦学习平台MP") {
                    return item.id == 856
                  }else {
                    return item.id == 907
                  }
                })
              }
              // this.styletext = item.columnText;
              // this.lineText = item.columnText
              // this.remark = item.remark;
              // this.textdata = data.list[0];
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    getContent(item) {
      let columnText=item
      if (columnText == "区块链无人值守传感器网络兆感"){
        columnText = "区块链无人值守传感器网络"
      }
      axios
        .get(
          "https://article.trilliontrust.com/publish-article/sys/column/byName?text=" +
            columnText,
          {}
        )
        .then(({ data }) => {
          if (data && data.code === 0) {
            if ((this.$route.query.item == "兆隐-国产区块链多方安全隐私计算联邦学习平台MP" || this.$route.query.item == "兆群：战术级边端侧无人武器装备集群侦控打智能协同指挥控制平台") && this.$route.query.text == "产品介绍") {
              data.list = data.list.filter((item) => {
                if (this.$route.query.item == "兆隐-国产区块链多方安全隐私计算联邦学习平台MP") {
                  return item.id == 856
                }else {
                  return item.id == 907
                }
              })
            }
            this.styletext = item;
            this.lineText=item
            this.textdata = data.list[0];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  components: {
    Mtcal,
    Stornet,
    Hashstor,
  },
};
</script>

<style scoped lang="scss">
.nav {
  margin-top: 78px;
  height: 220px;
  width: 100%;
  // background-color: #F5F9FC;
  // min-width: 1580px;
}

.fontSize {
  // width: 25%; //宽度
  // height: 28px; //高度
  font-size: 14px; //字体大小
  font-family: PingFangSC-Medium, PingFang SC; //字体样式
  margin-left: 30px;
  font-weight: 500; //字体加粗
  // color: #2d3036; //字体颜色
  line-height: 28px; //行高
  // position: relative;
  // top: -5px; //向上移动5px
}

.mtcal {
  // width: 100%;
  height: 63px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #282b31;
  line-height: 40px;
  margin-left: 15.5%;
  font-size: 20px;
  // position: relative;
  padding-top: 24px;
}

.btnBox {
  margin-left: 35%;
  margin-top: 20px;
  // margin-top: -5%;
  // margin-bottom: 8.5%;
  .btn {
    width: 120px;
    height: 39px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 14px;
    background: #0069fd;
    border-radius: 20px;
  }
}

.contents {
  //   width: 245px;
  background: #fafbfc;
  border-radius: 5px;
  border: 1px solid #d9e9ff;
  /*margin-left: 295px;*/
  //   margin-top: 35px;
  //   margin-bottom: 35px;
  //   padding-bottom: 44px;
  .image {
    float: right;
    position: relative;
    top: 8px;
    right: 20px;
  }
  .titleimg {
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    // line-height: 25px;
    text-align: center;
    margin: 14px 0px;
  }
}

.content_tyle{
  // width: 100%;
  margin-left: 5px;
  line-height: 10px;
  margin-right: 5px;
}
.content {

  background: #fafbfc;
  border-radius: 5px;
  border: 1px solid #d9e9ff;
  /*margin-left: 295px;*/
  //   margin-top: 35px;
  //   margin-bottom: 35px;
  padding-bottom: 44px;
  // width: 100%;
  height: 160px;
  background: url("../../assets/scheme/Page1.png") no-repeat center center;
  background-size: 100% 100%;
}

.titleimg2 {
  color: #2a67e3;
}
.subView {
  .subView_list {
    margin: 20px 5px 80px;
    .subView_item {
      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #282f3c;
        // margin-left: 9px;
      }
      .border {
        width: 45px;
        height: 3px;
        margin-top: 3px;
        background-color: #056dff;
      }
      .text {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 30px;
        font-size: 14px;
        margin: 20px 0;
        line-height: 30px;
        .imgCenter{
          text-align: center;
          padding: 20px 0;
          >img{
            width: 100%;
          }
        }
      }
    }
    .list {
      display: flex;
      .item {
        flex: 0.3;
        margin-top: 30px;
        &:last-child {
          margin-right: 0;
        }
        .item_img {
          padding-bottom: 30px;
          text-align: center;
        }
        .item_img img {
          /*width: 355px;*/
          margin-right: 30%;
        }
        .item_text {
          width: 100%;
          color: #333;
          margin-left: 50px;
          font-size: 14px;
          line-height: 23px;
          text-align: left;
        }
        .item_text01 {
          color: #333;
          font-size: 14px;
          line-height: 23px;
          text-align: left;
        }
      }
    }
    .center {
      text-align: center;
    }

    .blue {
      color: #2a67e3 !important;
    }
  }
}
</style>
